<template>
  <div class="login-container">
    <div class="login-box">
      <h1 class="login-title">维修知识管理系统</h1>
      <a-form
        :model="loginForm"
        :rules="rules"
        @finish="handleLogin"
        class="login-form"
      >
        <a-form-item name="username">
          <a-input
            v-model:value="loginForm.username"
            size="large"
            placeholder="请输入用户名"
            autocomplete="username"
          >
            <template #prefix>
              <UserOutlined />
            </template>
          </a-input>
        </a-form-item>
        <a-form-item name="password">
          <a-input-password
            v-model:value="loginForm.password"
            size="large"
            placeholder="请输入密码"
            autocomplete="current-password"
            @pressEnter="handleLogin"
          >
            <template #prefix>
              <LockOutlined />
            </template>
          </a-input-password>
        </a-form-item>
        <a-form-item>
          <a-button
            type="primary"
            html-type="submit"
            size="large"
            block
            :loading="loading"
          >
            登录
          </a-button>
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { ref, reactive } from 'vue';
import { useRouter } from 'vue-router';
import { message } from 'ant-design-vue';
import { UserOutlined, LockOutlined } from '@ant-design/icons-vue';
import { login } from '../api/auth';
import { setToken } from '../api/request';

export default {
  name: 'Login',
  components: {
    UserOutlined,
    LockOutlined
  },
  setup() {
    const router = useRouter();
    const loading = ref(false);
    const loginForm = reactive({
      username: '',
      password: ''
    });

    const rules = {
      username: [
        { required: true, message: '请输入用户名', trigger: 'blur' }
      ],
      password: [
        { required: true, message: '请输入密码', trigger: 'blur' }
      ]
    };

    const handleLogin = async () => {
      loading.value = true;
      
      try {
        // 调用后端登录接口
        const res = await login(loginForm.username, loginForm.password);
        
        if (res.code === 200 && res.data) {
          // 保存Token和用户信息
          setToken(res.data.token, res.data.refreshToken, res.data.user);
          
          message.success('登录成功');
          
          // 跳转到首页
          setTimeout(() => {
            router.push('/knowledge');
          }, 500);
        } else {
          message.error(res.message || '登录失败');
          loading.value = false;
        }
      } catch (error) {
        console.error('登录错误:', error);
        message.error(error.message || '登录失败');
        loading.value = false;
      }
    };

    return {
      loginForm,
      rules,
      loading,
      handleLogin
    };
  }
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}

.login-box {
  width: 400px;
  padding: 40px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

.login-title {
  text-align: center;
  margin-bottom: 32px;
  font-size: 24px;
  font-weight: 600;
  color: #333;
}

.login-form {
  margin-top: 24px;
}
</style>

